import { get, pickBy } from 'lodash';
import qs from 'qs';

export const generateNotificationsBackendParams = data => {
  const queryFields = {
    page: get(data, 'page'),
    size: get(data, 'size'),
    manager_id: get(data, 'managerId'),
  };

  return pickBy(queryFields, v => v !== undefined);
};

export const generateQueryFetchNotifications = data => {
  const params = generateNotificationsBackendParams(data);

  return qs.stringify(params, { arrayFormat: 'brackets' });
};
